module.exports = __webpack_public_path__ + "static/media/ssh-keys.69d3ba41.svg";